module.exports = __webpack_public_path__ + "media/images/news/yw-8ae162ac25ac2e7d624ba3ae9353ebb4.png";